import * as React from 'react'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Fetcher from '../../services/Api'

import * as style from './style.module.css'

const StyledCircularProgress = withStyles({
  root: {
    margin: 20
  }
})(CircularProgress)

export interface FetchResult {
  error: Error
  result: any
  loading: boolean
}

export interface FetchProps {
  children: (args: FetchResult) => JSX.Element
  resource: 'Swagger' | 'Apis' | 'Keys'
  apiId?: string
  userId?: string
  onLoaded?: (...args: any[]) => any | void
}

type IsFunction<T> = T extends (...args: any[]) => any ? T : never

const isFunction = <T extends {}>(value: T): value is IsFunction<T> => typeof value === 'function'

export class Fetch extends React.Component<FetchProps, FetchResult> {
  constructor(props: FetchProps) {
    super(props)
    this.state = {
      error: null,
      result: null,
      loading: true
    }
  }

  async componentDidMount() {
    let result: any;
    try {
      switch (this.props.resource) {
        case 'Apis':
          result = await new Fetcher().getApis()
          this.setState({
            result: result,
            loading: false
          })
          break
        case 'Swagger':
          result = await new Fetcher().getSwagger(this.props.apiId)
          this.setState({
            result: result,
            loading: false
          })
          break
        case 'Keys':
          result = await new Fetcher().getApiKeys(this.props.apiId, this.props.userId)
          this.setState({
            result: result,
            loading: false
          })
          break
      }
      // Execute callback function if provided
      if (this.props.onLoaded) {
        this.props.onLoaded()
      }
    }
    catch (err) {
      this.setState({
        error: err,
        loading: false
      })
    }
  }

  reload() {
    this.forceUpdate()
  }

  render() {
    const { children } = this.props

    if (!isFunction(children)) {
      throw new Error('children is mandatory and needs to be a function!')
    }

    if (this.state.loading === true) {
      return <div className={style.spinner}><StyledCircularProgress size="25%" /></div>
    }
    else {
      return (
        <div>
          {children({
            error: this.state.error,
            result: this.state.result,
            loading: this.state.loading
          })}
        </div>
      )
    }
  }
}

